
(function () {
    var TAG = "[Custom][GIC Keep]";
    var CONTAINER_SELECTOR = ".salepify-gic__gic-container";
    var MODAL_SELECTOR = ".salepify-gic__gift-selector-modal";
    var SUCCESS_BUTTON_SELECTOR = ".salepify-gic__gift-selector-add-to-cart-button--success";
    var MAX_PATCH_ATTEMPTS = 40;
    var RETRY_DELAY_MS = 250;
    var CLOSE_AFTER_SUCCESS_MS = 300;

    var keptNodes = [];
    var keptModal = null;

    function getMountPoints(widget) {
        var targets = widget.targetElements || {};
        var isEmpty = false;
        try {
            isEmpty = widget.isEmptyCart();
        } catch (err) {
            isEmpty = false;
        }
        var selector = isEmpty ? targets.emptySelector : targets.selector;
        var position = isEmpty ? targets.emptyPosition : targets.position;
        return {
            elements: selector ? Array.prototype.slice.call(document.querySelectorAll(selector)) : [],
            position: position,
        };
    }

    function isInPlace(target, node, position) {
        switch (position) {
            case "prepend":
            case "afterbegin":
                return target.firstElementChild === node;
            case "after":
            case "afterend":
                return target.nextElementSibling === node;
            default:
                return target.previousElementSibling === node;
        }
    }

    function insertAt(target, node, position) {
        switch (position) {
            case "prepend":
            case "afterbegin":
                target.prepend(node);
                break;
            case "after":
            case "afterend":
                target.insertAdjacentElement("afterend", node);
                break;
            default:
                target.insertAdjacentElement("beforebegin", node);
                break;
        }
    }

    // Gắn lại node đang giữ. true = đã lo xong, app không cần dựng lại widget.
    function reattach(widget) {
        keptNodes = keptNodes.filter(Boolean);
        if (!keptNodes.length) {
            return false;
        }
        var liveModal = document.querySelector(MODAL_SELECTOR);
        if (liveModal) {
            keptModal = liveModal;
        } else if (keptModal) {
            // Modal bị xoá cùng drawer (popup đang mở lúc theme re-render) → trả node cũ về body.
            document.body.appendChild(keptModal);
        } else {
            // Chưa từng thấy modal → để bản gốc chạy, thà nháy một nhịp còn hơn khách bấm chọn quà mà không mở được.
            return false;
        }

        var mount = getMountPoints(widget);
        if (!mount.elements.length) {
            return false;
        }
        // Theme đổi layout, cần nhiều container hơn số đang giữ → nhường app.
        if (keptNodes.length < mount.elements.length) {
            return false;
        }

        var moved = 0;
        mount.elements.forEach(function (target, i) {
            var node = keptNodes[i];
            if (!node || isInPlace(target, node, mount.position)) return;
            insertAt(target, node, mount.position);
            moved++;
        });

        try {
            if (typeof widget.setupOfferScroll === "function") widget.setupOfferScroll();
        } catch (err) {
            console.error(TAG, "Loi khi cap nhat scroll state:", err);
        }

        return true;
    }

    function getOffersWithoutCard(widget) {
        var offers = Array.isArray(widget.offers) ? widget.offers : [];
        if (!offers.length) return [];
        return offers.filter(function (offer) {
            var ruleKey = widget.utils.getRuleKey(offer.id, offer.module);
            return !document.querySelector('.salepify-gic__offer-card[data-rule-key="' + ruleKey + '"]');
        });
    }

    function rememberRenderedNodes() {
        try {
            keptNodes = Array.prototype.slice.call(document.querySelectorAll(CONTAINER_SELECTOR));
            keptModal = document.querySelector(MODAL_SELECTOR) || keptModal;
        } catch (err) {
            console.error(TAG, "Loi khi ghi nho container:", err);
        }
    }

    // --- Patch 1: renderGICWidget — tái dùng node cũ thay vì destroy-rebuild ---
    function patchRenderGICWidget(widget) {
        var originalRender = widget.renderGICWidget.bind(widget);

        widget.renderGICWidget = async function () {
            var reattached = false;
            try {
                reattached = reattach(widget);
            } catch (err) {
                console.error(TAG, "Loi khi gan lai widget, fallback render goc:", err);
            }

            if (reattached) {
                try {
                    var missing = getOffersWithoutCard(widget);
                    if (missing.length) await widget.addOfferCardsToGICContainer(missing);
                } catch (err) {
                    // Widget da nam dung cho roi, thieu card con hon dung lai ca widget (nhay).
                    console.error(TAG, "Loi khi bu card cho offer moi:", err);
                }
                return;
            }
            await originalRender();
            rememberRenderedNodes();
        };
    }

    function watchForDetach(widget) {
        if (!document.body) return; // script load trong <head> khong defer
        var scheduled = false;
        var schedule = typeof requestAnimationFrame === "function"
            ? requestAnimationFrame
            : function (fn) { return setTimeout(fn, 16); };

        var observer = new MutationObserver(function () {
            if (scheduled) return;
            scheduled = true;
            schedule(function () {
                scheduled = false;
                try {
                    var liveModal = document.querySelector(MODAL_SELECTOR);
                    if (liveModal) keptModal = liveModal;

                    var detached = keptNodes.some(function (node) {
                        return node && !node.isConnected;
                    });
                    if (detached) {
                        reattach(widget);
                    }
                } catch (err) {
                    console.error(TAG, "Loi trong observer:", err);
                }
            });
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    function closePopupOnClaimSuccess(widget) {
        if (!document.body) return;

        new MutationObserver(function () {
            var btn = document.querySelector(SUCCESS_BUTTON_SELECTOR);
            if (!btn || btn.dataset.gicClosedEarly) return;
            btn.dataset.gicClosedEarly = "1"; // core vẫn gọi đóng lần nữa sau 2s, lần đó thành no-op
            setTimeout(function () {
                try {
                    widget.toggleGiftSelector(false);
                } catch (err) {
                    console.error(TAG, "Loi khi dong popup sau khi claim:", err);
                }
            }, CLOSE_AFTER_SUCCESS_MS);
        }).observe(document.body, { subtree: true, attributes: true, attributeFilter: ["class"] });
    }

    function patchWidget() {
        try {
            var widget = window.tlGiftInCartWidget;
            if (!widget || typeof widget.renderGICWidget !== "function" || widget.__gicKeepMountedPatched) {
                return false;
            }

            patchRenderGICWidget(widget);
            rememberRenderedNodes(); // widget có thể đã render xong trước khi script này chạy
            watchForDetach(widget);
            closePopupOnClaimSuccess(widget);

            widget.__gicKeepMountedPatched = true;
            return true;
        } catch (err) {
            console.error(TAG, "Loi khi patch tlGiftInCartWidget:", err);
            return true; // dừng retry, tránh lặp lỗi
        }
    }

    try {
        var attempts = 0;
        var timer = setInterval(function () {
            try {
                attempts++;
                if (patchWidget() || attempts >= MAX_PATCH_ATTEMPTS) {
                    clearInterval(timer);
                }
            } catch (tickErr) {
                console.error(TAG, "Loi trong vong lap patch:", tickErr);
                clearInterval(timer);
            }
        }, RETRY_DELAY_MS);
    } catch (outerErr) {
        console.error(TAG, "Loi khoi tao script:", outerErr);
    }
})();
